/** Shared scroll-reveal presets for homepage sections */
export const inViewOnce = {
  once: true,
  amount: 0.28,
  margin: '0px 0px -40px 0px',
};

/** Tall stagger wrappers: a numeric `amount` can fail because max intersection ratio is ~viewportHeight / elementHeight */
export const inViewOnceStagger = {
  once: true,
  amount: 'some',
  margin: '0px 0px -40px 0px',
};

/** First homepage work tile: reveal as soon as it enters the viewport */
export const inViewFirstHomeWork = {
  once: true,
  amount: 0.05,
  margin: '0px 0px 0px 0px',
};

export const revealEase = [0.25, 0.1, 0.25, 1];

export const revealTransition = {
  duration: 0.52,
  ease: revealEase,
};

export const fadeUpHidden = { opacity: 0, y: 18 };
export const fadeUpVisible = {
  opacity: 1,
  y: 0,
  transition: revealTransition,
};

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.065, delayChildren: 0.06 },
  },
};

export const itemFade = {
  hidden: fadeUpHidden,
  visible: {
    opacity: 1,
    y: 0,
    transition: revealTransition,
  },
};
